import { combineReducers } from "@reduxjs/toolkit";
import VisitorsReducer from "../features/Visitors/VisitorsReducer";
import CompanyGroupsReducer from "../features/CompanyGroups/CompanyGroupsReducer";
import PropertyReducer from "../features/Property/PropertyReducer";
import { SignInReducer } from "features/SignIn/SignInReducer";
import CompReducer from "../features/Comp/CompReducer";
import DealsReducer from "../features/Deals/DealsReducer";
import AssistantPagesReducer from "../features/AssistantPages/AssistantPagesReducer";
import MarketAreasReducer from "../features/MarketAreas/MarketAreasReducer";
import { Actions as VisitorActions } from "features/Visitors/interfaces";
import { Actions as SignInActions } from "features/SignIn/interfaces";
import { Actions as CompanyActions } from "features/CompanyGroups/interfaces";
import { Actions as PropertyActions } from "features/Property/interfaces";
import { Actions as CompActions } from "features/Comp/interfaces";
import { Actions as DealsActions } from "features/Deals/interfaces";
import { Actions as AssistantPagesActions } from "features/AssistantPages/interfaces";
import { Actions as MarketAreasActions } from "features/MarketAreas/interfaces";
import templatesSlice from "features/Templates/slice";
import { tableFiltersSlice } from "features/tableFilters";
import assetDashboardSlice from "features/AssetDashboard/slice";
import competitorsSlice from "features/Competitors/slice";
import demographicsSlice from "features/Demographics/slice";
import reviewsSlice from "features/Reviews/slice";
import portfolioSlice from "features/Portfolio/slice";
import marketAreaModeSlice from "features/MarketAreaDrawing/mode/slice";
import marketAreaRadiusSlice from "features/MarketAreaDrawing/radius/slice";
import marketAreaPolygonSlice from "features/MarketAreaDrawing/polygon/slice";
import marketAreaDriveTimeSlice from "features/MarketAreaDrawing/driveTime/slice";
import marketAreaAdministrativeGeographySlice from "features/MarketAreaDrawing/administrativeGeography/slice";
import researchSlice from "features/Research/slice";
import researchFiltersSlice from "features/Research/filterSlice";

const appReducer = combineReducers({
  marketAreaMode: marketAreaModeSlice.reducer,
  marketAreaRadius: marketAreaRadiusSlice.reducer,
  marketAreaPolygon: marketAreaPolygonSlice.reducer,
  marketAreaDriveTime: marketAreaDriveTimeSlice.reducer,
  marketAreaAdministrativeGeography:
    marketAreaAdministrativeGeographySlice.reducer,
  templates: templatesSlice.reducer,
  tableFilters: tableFiltersSlice.reducer,
  assetDashboard: assetDashboardSlice.reducer,
  competitors: competitorsSlice.reducer,
  demographics: demographicsSlice.reducer,
  reviews: reviewsSlice.reducer,
  portfolio: portfolioSlice.reducer,
  research: researchSlice.reducer,
  researchFilters: researchFiltersSlice.reducer,
  VisitorsReducer,
  SignInReducer,
  CompanyGroupsReducer,
  PropertyReducer,
  CompReducer,
  DealsReducer,
  AssistantPagesReducer,
  MarketAreasReducer,
});

export type RootState = ReturnType<typeof appReducer>;

const rootReducer = (
  state: RootState | undefined,
  action:
    | VisitorActions
    | SignInActions
    | CompanyActions
    | PropertyActions
    | CompActions
    | DealsActions
    | AssistantPagesActions
    | MarketAreasActions
) => {
  if (action.type === "USER_LOG_OUT") {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

export default rootReducer;
